/* Own only the initial logo; the established hero owns the photograph/copy. */
(() => {
  'use strict';
  const root = document.documentElement;
  const splash = document.getElementById('BrandSplash');
  if (!splash) return;
  const events = new AbortController();
  const timers = new Set();
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const logo = splash.querySelector('.brand-opening__source');
  let ended = false;
  let started = false;
  let readyTimer;

  function later(callback, ms) {
    const timer = setTimeout(() => { timers.delete(timer); callback(); }, ms);
    timers.add(timer);
    return timer;
  }
  function finish() {
    if (ended) return;
    ended = true;
    timers.forEach(clearTimeout);
    events.abort();
    splash.remove();
    root.classList.remove('is-splashing');
    clearTimeout(window.totoOpeningFallback);
    delete window.totoOpeningFallback;
  }
  function start() {
    if (ended || started) return;
    if (document.hidden || motion.matches || !splash.isConnected) { finish(); return; }
    started = true;
    clearTimeout(readyTimer);
    splash.classList.add('is-active');
    try { sessionStorage.setItem('totocola:splash-seen', '1'); } catch (_) { /* Optional storage. */ }
    later(() => {
      // The hero starts beneath the fading cover, with no blank intermission.
      splash.classList.add('is-leaving');
      root.classList.remove('is-splashing');
    }, 1450);
    later(finish, 2450);
  }

  const nav = performance.getEntriesByType('navigation')[0];
  if (!root.classList.contains('is-splashing') || motion.matches || location.hash ||
      window.Shopify?.designMode || nav?.type === 'back_forward' || window.scrollY > 1) {
    finish();
    return;
  }
  ['pagehide', 'beforeprint'].forEach(name => window.addEventListener(name, finish, { signal: events.signal }));
  window.addEventListener('pageshow', event => { if (event.persisted) finish(); }, { signal: events.signal });
  document.addEventListener('visibilitychange', () => { if (document.hidden) finish(); }, { signal: events.signal });
  document.addEventListener('focusin', finish, { signal: events.signal });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' || event.key === 'Tab') finish();
  }, { capture: true, signal: events.signal });
  document.addEventListener('pointerdown', event => {
    if (event.target.closest?.('a, button, input, select, textarea, summary')) finish();
  }, { capture: true, signal: events.signal });
  motion.addEventListener('change', finish, { signal: events.signal });
  window.addEventListener('resize', finish, { signal: events.signal });

  // Never show a broken logo or wait indefinitely for an unavailable asset.
  if (!logo) { start(); return; }
  if (logo.complete) { if (logo.naturalWidth) start(); else finish(); return; }
  logo.addEventListener('load', start, { once: true, signal: events.signal });
  logo.addEventListener('error', finish, { once: true, signal: events.signal });
  readyTimer = later(finish, 900);
})();
